<template lang="pug">
    v-card
        model-data-table(
            :service="service"
            :headers="headers"
            :filters="filters"
            no-search
            no-actions
            remind-key='accounting-notes-list'
            )
        //- crud-data-table(
        //-     :service="service"
        //-     :headers="headers"
        //-     :filters="filters"
        //-     noActions
        //-     )
        crud-create-button(
            text="Conciliar" 
            :action="() => $router.push('/account_conciliation')"
            v-if="$can('EDIT_ACCOUNTING_NOTE')"
            )
</template>

<script>
import { CrudCreateButton } from '@/components/reusable_components'
import ModelDataTable from '@/components/reusable_components/next/ModelDataTable'
import { getFetchDataFunction } from '../../services/api/DataTableService'
import { NotesHeaders as headers } from './headers'
import FiltersAccountingNotes from './FiltersAccountingNotes'
import { getAllAccounts } from '@/services/api/account'
import UserService from '@/services/api/user'
import { getAllStatus } from '@/services/api/accountingSeat'
import { mapActions } from 'vuex'
import AccAccountingNote from '@/models/Accounting/AccAccountingNote'
export default {
    name: 'component-name',
    props: {},
    data: function() {
        return {
            service: AccAccountingNote,
            headers: headers,
            filters: FiltersAccountingNotes,
        }
    },
    computed: {},
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        //-
        setFilterOptions(index, options) {
            this.filters[index].options = options
        },
        //-
        mapUserToFilter: ({ hr_employee, id }) => ({
            text: [
                hr_employee.names,
                hr_employee.last_name1,
                hr_employee.last_name2,
            ].join(' '),
            value: id,
        }),
        //-
        mapAccountToFilter: ({ comment, id }) => ({
            text: comment,
            value: id,
        }),
        //-
        mapStatusToFilter: ({ status, id }) => ({
            text: status,
            value: id,
        }),
    },
    watch: {},
    components: {
        'crud-create-button': CrudCreateButton,
        'model-data-table': ModelDataTable,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    beforeMount: async function() {
        let accounts = await getAllAccounts()
        let users = await UserService.fetchAll()
        let status = await getAllStatus()
        this.setFilterOptions(0, accounts.data.map(this.mapAccountToFilter))
        this.setFilterOptions(1, users.map(this.mapUserToFilter))
        this.setFilterOptions(2, status.data.map(this.mapStatusToFilter))
    },
    created: function() {
        this.setTitleTopBar('Apuntes contables')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_ACCOUNTING_NOTE')) ctx.$router.push('/')
        })
    },
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>